import React, { useState } from 'react';
import { ClipboardCopyButton, CodeBlock, CodeBlockAction, CodeBlockCode } from '@patternfly/react-core';

interface CopyableCodeBlockProps {
  id: string;
  code: string;
  copyLabel: string;
}

// A CodeBlock with a copy-to-clipboard action, shared by the per-platform deployment
// instruction tabs on the Agent page.
export const CopyableCodeBlock: React.FC<CopyableCodeBlockProps> = ({ id, code, copyLabel }) => {
  const [copied, setCopied] = useState(false);

  return (
    <CodeBlock
      actions={
        <CodeBlockAction>
          <ClipboardCopyButton
            id={id}
            aria-label={copyLabel}
            variant="plain"
            onClick={() => {
              void navigator.clipboard.writeText(code);
              setCopied(true);
            }}
            exitDelay={copied ? 1500 : 600}
            onTooltipHidden={() => setCopied(false)}
          >
            {copied ? 'Copied' : copyLabel}
          </ClipboardCopyButton>
        </CodeBlockAction>
      }
    >
      <CodeBlockCode>{code}</CodeBlockCode>
    </CodeBlock>
  );
};
